import {
  Table,
  Button,
  Divider,
  Input,
  Select,
  Tag,
  Row,
  Col,
  DatePicker,
  Slider,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';
import moment from 'moment';
const Option = Select.Option;
const { RangePicker } = DatePicker;

import _ from 'lodash';

class TablaExpedientes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarTipo: '',
      textoBuscarNro: '',
      textoBuscarOrg: '',
      textoBuscarAnio: '',
      buscarFechaIngreso: null,
      buscarFechaPrescripcion: 0,
      verFiltroTipo: false,
      verFiltroNro: false,
      verFiltroOrg: false,
      verFiltroAnio: false,
      verFiltroFechaIngreso: false,
      verFiltroFechaPrescripcion: false,
      filtered: false,
    };
  }

  handleChange(value) {
    console.log(`selected ${value}`);
  }

  render() {
    const columns = [
      {
        title: 'Tipo',
        dataIndex: ['tipo', 'nombre'],
        key: 'tipo',
        align: 'center',
        filterDropdown: this.props.filtrarPorTipo ? (
          <div className="custom-filter-dropdown">
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Elegir Tipo Exp."
              optionFilterProp="children"
              allowClear
              onChange={value => this.props.filtrarPorTipo(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {_.map(this.props.tiposExpedientes, tipo => {
                return (
                  <Option key={tipo.value} value={tipo.value}>
                    {tipo.text}
                  </Option>
                );
              })}
            </Select>
            {/* <Button
              type="primary"
              onClick={() => this.props.filtrarPorTipo(null)}
            >
              REINICIAR
            </Button> */}
          </div>
        ) : (
          undefined
        ),
        filterIcon: this.props.filtrarPorTipo ? (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ) : (
          undefined
        ),
        filterDropdownVisible: this.props.filtrarPorTipo
          ? this.state.verFiltroTipo
          : undefined,
        onFilterDropdownVisibleChange: this.props.filtrarPorTipo
          ? visible => {
              this.setState(
                {
                  verFiltroTipo: visible,
                },
                () => this.searchInput && this.searchInput.focus()
              );
            }
          : undefined,
      },
      {
        title: 'Codigo',
        align: 'center',
        dataIndex: 'codigoOrganismo',
        key: 'codigo',
      },
      {
        title: 'Numero',
        dataIndex: 'numero',
        align: 'center',
        key: 'numero',
        filterDropdown: this.props.filtrarPorNro ? (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              style={{ width: 120 }}
              placeholder="Buscar Nro"
              value={this.state.textoBuscarNro}
              onChange={e => this.setState({ textoBuscarNro: e.target.value })}
              onPressEnter={() =>
                this.props.filtrarPorNro(this.state.textoBuscarNro)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorNro(this.state.textoBuscarNro)
              }
            >
              Buscar Nro
            </Button>
          </div>
        ) : (
          undefined
        ),
        filterIcon: this.props.filtrarPorNro ? (
          <Icons.FilterOutlined
            style={{
              color:
                this.state.filtrarPorNro && this.state.filtrarPorNro.length > 0
                  ? '#108ee9'
                  : '#aaa',
            }}
          />
        ) : (
          undefined
        ),
        filterDropdownVisible: this.props.filtrarPorNro
          ? this.state.verFiltroNro
          : undefined,
        onFilterDropdownVisibleChange: this.props.filtrarPorNro
          ? visible => {
              this.setState(
                {
                  verFiltroNro: visible,
                },
                () => this.searchInput && this.searchInput.focus()
              );
            }
          : undefined,
      },
      {
        title: 'Año',
        dataIndex: 'anio',
        align: 'center',
        key: 'anio',
        filterDropdown: this.props.filtrarPorAnio ? (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar Año"
              style={{ width: 120 }}
              value={this.state.textoBuscarAnio}
              allowClear
              onChange={e => this.setState({ textoBuscarAnio: e.target.value })}
              onPressEnter={() =>
                this.props.filtrarPorAnio(this.state.textoBuscarAnio)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorAnio(this.state.textoBuscarAnio)
              }
            >
              Buscar Año
            </Button>
          </div>
        ) : (
          undefined
        ),
        filterIcon: this.props.filtrarPorAnio ? (
          <Icons.FilterOutlined
            style={{
              color:
                this.state.textoBuscarAnio &&
                this.state.textoBuscarAnio.length > 0
                  ? '#108ee9'
                  : '#aaa',
            }}
          />
        ) : (
          undefined
        ),
        filterDropdownVisible: this.props.filtrarPorAnio
          ? this.state.verFiltroAnio
          : undefined,
        onFilterDropdownVisibleChange: this.props.filtrarPorAnio
          ? visible => {
              this.setState(
                {
                  verFiltroAnio: visible,
                },
                () => this.searchInput && this.searchInput.focus()
              );
            }
          : undefined,
      },
      {
        title: 'F. Ingreso',
        dataIndex: 'fechaIngreso',
        align: 'center',
        key: 'fechaIngreso',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
        filterDropdown: this.props.filtrarPorFechaIngreso ? (
          <div className="custom-filter-dropdown">
            <RangePicker
              ref={ele => (this.searchInput = ele)}
              placeholder={['Inicio', 'Fin']}
              style={{ width: 300 }}
              // value={[this.state.buscarFechaIngresoInicio, this.state.buscarFechaIngresoFin]}
              onChange={date => {
                if (date == null) {
                  this.props.filtrarPorFechaIngreso(null, null);
                } else {
                  this.setState(
                    {
                      buscarFechaIngresoInicio: date[0]
                        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                        .toDate(),
                      buscarFechaIngresoFin: date[1]
                        .set({
                          hour: 23,
                          minute: 59,
                          second: 59,
                          millisecond: 0,
                        })
                        .toDate(),
                    },
                    () =>
                      this.props.filtrarPorFechaIngreso(
                        this.state.buscarFechaIngresoInicio,
                        this.state.buscarFechaIngresoFin
                      )
                  );
                }
              }}
              onPressEnter={() =>
                this.props.filtrarPorFechaIngreso(
                  this.state.buscarFechaIngresoInicio,
                  this.state.buscarFechaIngresoFin
                )
              }
              format={'DD-MM-YYYY'}
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorFechaIngreso(
                  this.state.buscarFechaIngresoInicio,
                  this.state.buscarFechaIngresoFin
                )
              }
            >
              Buscar Fecha
            </Button>
          </div>
        ) : (
          undefined
        ),
        filterIcon: this.props.filtrarPorFechaIngreso ? (
          <Icons.FilterOutlined
            style={{
              color: this.state.buscarFechaIngresoInicio ? '#108ee9' : '#aaa',
            }}
          />
        ) : (
          undefined
        ),
        filterDropdownVisible: this.props.filtrarPorFechaIngreso
          ? this.state.verFiltroFechaIngreso
          : undefined,
        onFilterDropdownVisibleChange: this.props.filtrarPorFechaIngreso
          ? visible => {
              this.setState(
                {
                  verFiltroFechaIngreso: visible,
                },
                () => this.searchInput && this.searchInput.focus()
              );
            }
          : undefined,
      },
      {
        title: 'F. Prescripcion',
        dataIndex: 'fechaPrescripcion',
        align: 'center',
        key: 'fechaPrescripcion',
        render: fecha => {
          if (fecha) {
            if (moment(fecha) > moment()) {
              return moment(fecha).format('DD/MM/YYYY');
            } else {
              return (
                <Tag color="#e31305">{moment(fecha).format('DD/MM/YYYY')}</Tag>
              );
            }
          } else {
            return 'SIN DATOS';
          }
        },
        filterDropdown: this.props.filtrarPorFechaPrescripcion ? (
          <div className="custom-filter-dropdown" style={{ padding: 25 }}>
            <h4
              style={{
                textAlign: 'center',
              }}
            >
              DIAS HASTA LA PRESCRIPCION
            </h4>
            <Slider
              marks={{
                0: {
                  style: {
                    color: '#f50',
                  },
                  label: <strong>Prescriptos</strong>,
                },
                1: '1 Semana',
                2: '2 Semanas',
                3: '3 Semanas',
                4: '1 Mes',
              }}
              step={null}
              min={0}
              max={4}
              style={{
                width: 450,
                margin: 30,
              }}
              value={this.state.buscarFechaPrescripcion}
              onChange={valor =>
                this.setState({
                  buscarFechaPrescripcion: valor,
                })
              }
            />

            <Button
              type="danger"
              style={{ margin: 5, marginLeft: 125 }}
              onClick={() => {
                this.setState({ buscarFechaPrescripcion: 0 });
                this.props.filtrarPorFechaPrescripcion(null);
              }}
            >
              Reiniciar
            </Button>
            <Button
              type="primary"
              style={{ margin: 5 }}
              onClick={() =>
                this.props.filtrarPorFechaPrescripcion(
                  this.state.buscarFechaPrescripcion
                )
              }
            >
              Buscar Fecha
            </Button>
          </div>
        ) : (
          undefined
        ),
        filterIcon: this.props.filtrarPorFechaPrescripcion ? (
          <Icons.FilterOutlined
            style={{
              color: this.state.buscarFechaPrescripcion ? '#108ee9' : '#aaa',
            }}
          />
        ) : (
          undefined
        ),
        filterDropdownVisible: this.props.filtrarPorFechaPrescripcion
          ? this.state.verFiltroFechaPrescripcion
          : undefined,
        onFilterDropdownVisibleChange: this.props.filtrarPorFechaPrescripcion
          ? visible => {
              this.setState(
                {
                  verFiltroFechaPrescripcion: visible,
                },
                () => this.searchInput && this.searchInput.focus()
              );
            }
          : undefined,
      },
      {
        title: 'N° Docs',
        align: 'center',
        key: 'numDocs',
        // width: 100,
        render: exp => (exp.actuaciones ? exp.actuaciones.length : 0),
      },
      {
        title: 'Estado',
        key: 'estado',
        align: 'center',
        dataIndex: 'estado',
        render: text => {
          if (text == 'EN TRAMITE') {
            return <Tag color="#108ee9">EN TRAMITE</Tag>;
          }
          if (text == 'FINALIZADO') {
            return <Tag color="#f50">FINALIZADO</Tag>;
          }
          if (text == 'OTRO') {
            return <Tag color="#2db7f5">OTRO</Tag>;
          } else {
            return <Tag color="#f44295"> SIN ASIGNAR </Tag>;
          }
        },
        filterDropdown: this.props.filtrarPorEstado ? (
          <div className="custom-filter-dropdown">
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Elegir Estado"
              optionFilterProp="children"
              allowClear
              onChange={value => {
                this.setState({
                  filtered: true,
                });
                this.props.filtrarPorEstado(value);
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="EN TRAMITE">
                <Tag color="#108ee9">EN TRAMITE</Tag>
              </Option>
              <Option value="FINALIZADO">
                <Tag color="#f50">FINALIZADO</Tag>
              </Option>
              <Option value="OTRO">
                <Tag color="#2db7f5">OTRO</Tag>
              </Option>
            </Select>
            {/* <Button
              type="primary"
              onClick={() => {
                this.setState({
                  filtered: false,
                });
                this.props.filtrarPorEstado(null);
              }}
            >
              REINICIAR
            </Button> */}
          </div>
        ) : (
          undefined
        ),
        filterIcon: this.props.filtrarPorEstado ? (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ) : (
          undefined
        ),
        filterDropdownVisible: this.props.filtrarPorEstado
          ? this.state.verFiltroEstado
          : undefined,
        onFilterDropdownVisibleChange: this.props.filtrarPorEstado
          ? visible => {
              this.setState(
                {
                  verFiltroEstado: visible,
                },
                () => this.searchInput && this.searchInput.focus()
              );
            }
          : undefined,
      },
      {
        title: 'Acciones',
        key: 'acciones',
        align: 'center',
        render: (text, record) => (
          <span>
            <Button
              type="primary"
              onClick={() =>
                this.props.history.push(
                  `/contravenciones/expedientes/${record._id}`
                )
              }
            >
              Ver
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              stlye={{ width: 50 }}
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { expedientes } = this.props;
    const paginationOptions = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.tamPagina ? this.props.tamPagina : null,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };
    return (
      <Table
        rowKey="_id"
        columns={columns}
        bordered
        dataSource={expedientes}
        loading={this.props.loadingTabla}
        pagination={paginationOptions}
        title={() => (
          <Row>
            <Col span={6}>Cantidad Expedientes: {this.props.total}</Col>
            <Col span={8} offset={2}>
              <h2 style={{ textAlign: 'center' }}> Expedientes </h2>
            </Col>

            {this.props.onVolver && (
              <Col span={8}>
                <Button type="danger" onClick={this.props.onVolver}>
                  Volver
                </Button>
              </Col>
            )}
          </Row>
        )}
        locale={{
          emptyText: 'No hay tipo expedientes cargados',
        }}
      />
    );
  }
}

export default TablaExpedientes;
